import { render, staticRenderFns } from "./receiveStatistics.vue?vue&type=template&id=24e459f6&scoped=true"
import script from "./receiveStatistics.vue?vue&type=script&lang=js"
export * from "./receiveStatistics.vue?vue&type=script&lang=js"
import style0 from "./receiveStatistics.vue?vue&type=style&index=0&id=24e459f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e459f6",
  null
  
)

export default component.exports